(function() {
  'use strict';

  function ReportWrapperController($scope, ReportViewer, Utils, ReportWrapperService) {
    var ctrl = this;

    ctrl.$onChanges = function() {
      ctrl.showActionButtons = ctrl.showActionButtons || false;
      ctrl.reportData = ctrl.getReportData();
      ctrl.reportViewer = ctrl.getReportViewer();
      ReportWrapperService.reportViewer = ctrl.reportViewer;
      ctrl.reportTemplate = 'blueprint-coverage';
      ctrl.loaded = false;
      setTimeout(function() {
        ctrl.reportViewer.init()
          .then(function() {
            ctrl.list = ctrl.reportViewer.list;
            ctrl.list.doLoadItems();
            ctrl.loaded = true;
            $scope.$broadcast('reportsviewer.viewUpdated');
          })
          .catch(function(error) {
            Utils.showError(error);
            ctrl.loaded = true;
          });
      });
      ctrl.reportViewer.overview = '';
    };

    ctrl.getReportViewer = function() {
      return new ReportViewer({ reportData: ctrl.reportData }, { forUser: ctrl.user });
    };

    ctrl.getReportData = function() {
      return {
        blueprint: ctrl.blueprintId,
        blueprintCatId: ctrl.blueprintCatId === 'any' ? null : ctrl.blueprintCatId,
        reportType: 'coverage',
        restrictionType: 'none'
      };
    };
  }

  ReportWrapperController.$inject = [
    '$scope', 'ReportViewerFactory', 'UtilsService', 'ReportWrapperService'
  ];

  angular.module('component.reports')
    .component('reportWrapperComponent', {
      controller: ReportWrapperController,
      templateUrl: 'app/components/reports/report.wrapper.html',
      bindings: {
        showActionButtons: '<',
        user: '<',
        blueprintId: '<',
        blueprintCatId: '<'
      }
    });
})();
